import BadgetRoxo from './badget-roxo'
import CardServicos from './cardServicos'
import Container from './container'

export default function SoftwareCards() {
  const mock = [
    {
      icon: '../assets/servicos/equipe_icon.svg',
      iconHover: '../assets/servicos/equipe_icon.svg',
      title: 'Equipe de especialistas',
      text: 'Nossa equipe é formada por arquitetos de software altamente qualificados e experientes, com expertise sólida e conhecimento técnico certificado nas mais recentes tecnologias e conectados com as tendências do mercado.',
      glowColor: '#D700E2',
      url: '',
    },
    {
      icon: '../assets/servicos/inovacao_continua_icon.svg',
      iconHover: '../assets/servicos/inovacao_continua_icon.svg',
      title: 'Inovação contínua',
      text: 'Exploramos continuamente as novas tecnologias e metodologias para garantir projetos de impacto para nossos clientes.',
      glowColor: '#D700E2',
      url: '',
    },
    {
      icon: '../assets/servicos/compromisso_excelencia_icon.svg',
      iconHover: '../assets/servicos/compromisso_excelencia_icon.svg',
      title: 'Compromisso com a excelência',
      text: 'Somos comprometidos com a excelência e asseguramos suporte contínuo e evolutivo para garantir que as soluções de projeto sejam eficientes, eficazes e tragam sucesso para os clientes.',
      glowColor: '#D700E2',
      url: '',
    },
  ]

  return (
    <div className="w-full bg-[#040116] py-[74px] md:py-20 relative overflow-hidden text-white">
      <Container className="relative z-10 space-y-6">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {mock.map((item, index) => (
            <div key={index}>
              <CardServicos
                icon={item.icon}
                iconHover={item.iconHover}
                title={item.title}
                text={item.text}
                glowColor={item.glowColor}
                url={item.url}
                height={380}
                className="w-full aspect-square lg:aspect-auto lg:h-full"
              />

              {index === 0 && (
                <BadgetRoxo
                  titulo={
                    <>
                      Otimize seu <br className="hidden md:inline-block" />{' '}
                      negócio!
                    </>
                  }
                  textoBotao="Contratar"
                  className="md:hidden mt-4"
                />
              )}
            </div>
          ))}
        </div>
        <div className="hidden md:block">
          <BadgetRoxo
            titulo={
              <>
                Otimize seu <br className="hidden md:inline-block" /> negócio!
              </>
            }
            textoBotao="Contratar"
            className="hidden md:flex md:w-[calc(50%-12px)] lg:w-[calc(360.33px-16px)]"
          />
        </div>
      </Container>
    </div>
  )
}
